import React from "react";
import ReactApexChart from "react-apexcharts";
import Image from "../../assets/images/emergency.png";
import useWindowDimensions from "../../utils/useWindowDimensions";

const ViolationCompare = ({ violationCount, nonViolationCount }) => {
  let { width } = useWindowDimensions();
  const chartData = {
    series: [violationCount ?? 0, nonViolationCount ?? 0],

    options: {
      labels: ["Violation", "Non-violation"],
      chart: {
        type: "donut",
        stroke: {
          show: false,
        },
      },
      legend: {
        position: "bottom",
        show: false,
      },
      colors: ["#ca373c", "#333333"],
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: "17px",
                lineHeight: "1",
              },
              value: {
                show: true,
                fontSize: "14px",
                lineHeight: "1",
                color: "#000",
                offsetX: 5,
              },
              total: {
                show: true,
                label: "Total",
                fontSize: "13px",
                fontWeight: "bold",
                color: "#000",
              },
            },
          },
        },
      },
      stroke: {
        width: 0,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  };

  return (
    <>
      <div id="chart" className={width > 1500 ? "pt-3 " : "pt-2"} style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly", gap: "0px", flexDirection: "column" }}>
        <ReactApexChart options={chartData.options} series={chartData.series} type="donut" 
        height={(width > 1400 && width < 1700) ? 230 : width >= 1700 ? 280 : 200}
        width={(width > 1400 && width < 1700) ? 300 : width >= 1700 ? 300 : 300}
        />
        <div className='chartlegends' >
          <p className='language' > <span>{""}</span> With Violations : <strong> {violationCount ?? 0} </strong>{" "} </p>
          <p className='language' > <span>{""}</span> With Non Violations : <strong> {nonViolationCount ?? 0} </strong>{" "}</p>
        </div>
      </div>
    </>
  );
};

export default ViolationCompare;
